import { ButtonHook } from 'common/Prose/Toolbar/Types'
import { computed } from 'mobx'
import { schema } from 'prose-core'
import { EditorView } from 'prosemirror-view'
import { useContext } from 'react'
import { AlmanacEditorStateContext } from 'stores/EditorState'
import { timedOutToggleMark } from '../utils/util'
import { PressEvent } from '@react-types/shared/src/events'

export function useItalicToggle(view: EditorView): ButtonHook<(e: PressEvent) => void> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const almanacState = useContext(AlmanacEditorStateContext)!

  const hasItalic = computed(() => almanacState.activeMarks.has(schema.marks.em)).get()

  const hasCodeBlock = computed(() => almanacState.activeNodes.has(schema.nodes.code_block)).get()

  return { active: hasItalic, handleClick: timedOutToggleMark(schema.marks.em, view), disabled: hasCodeBlock }
}
